import { get, post, del} from '../../ReaderlyHttpClient';
import { GetWishListResponse, WISHLIST_SERVICE_URLS } from './Data';

export class WishListService {

  async AddToWishlist(itemId: number) {
    // Adding an item already in the wishlist returns 400 — callers handle that
    // case explicitly instead of showing the generic global error toast.
    return await post<void, { id: number }>(WISHLIST_SERVICE_URLS.GET_WISHLIST, { id: itemId }, undefined, {
      suppressGlobalError: true,
    });
  }

  async GetWishList(index: number, count: number) {
      const params: Record<string, string> = {};
      params.index = index.toString();
      params.count = count.toString();
      
      return await get<GetWishListResponse>(WISHLIST_SERVICE_URLS.PUT_ITEM_TO_WISHLIST, params);
  }

  async DeleteFromWishList(itemId: number) {
    const params: Record<string, string> = {}
    params.itemId = itemId.toString();
    return await del<any>(WISHLIST_SERVICE_URLS.DELETE_FROM_WISHLIST, params, { suppressGlobalError: true });
  }
}

const wishListServiceInstance = new WishListService();

export default wishListServiceInstance;
